import React from 'react';
import { Politica, Footer } from '../../components';
import { ContainerFluid } from './index.styled';

const PoliticaPrivacidadePage = () => {
  return (
    <ContainerFluid>
      <Politica />
      <Footer />
    </ContainerFluid>
  );
};

export default PoliticaPrivacidadePage;
